import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";

import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Covid from "../../Assets/Projects/Covid.png";
import Todo from "../../Assets/Projects/To-do.png";
import AMS from "../../Assets/Projects/AMS.png";
import weather from "../../Assets/Projects/weather.png";
import paint from "../../Assets/Projects/paint.png";
import Hsmjava from "../../Assets/Projects/HSMJAVA.png";
import Hsm from "../../Assets/Projects/HSMJAVA.gif";
import MP3 from "../../Assets/Projects/MP3.png"
import MiniMp3 from "../../Assets/Projects/minimp3.png"
import website from "../../Assets/Projects/Website.png"
import gallery from "../../Assets/Projects/gallery.gif"
import AI from "../../Assets/Projects/AI.jpeg"
import Mario from "../../Assets/Projects/Mario.png"




function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Covid}
              isBlog={false}
              title="A Covid-19 App"
            
              description="The Android application shows the location of the containment zones to the users. It also notifies the user when he or she trespasses the boundary of a containment zone or stays in the containment zones.A Real Time Tracking app to track recovery rate,deaths,new cases and nation wide helpline & essentials page."
              link="https://imgur.com/a/orNnQti"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AI}
              isBlog={false}
              title="Cube Solving Script Using AI"
              
              description=" This project utilizes the OpenCV libraries and Kociemba’s algorithm to solve an unsolved Rubik’s Cube. By scanning the cube’s faces with a webcam, the program generates a solved Rubik’s Cube in just 30 moves. It’s a unique and impressive application of computer vision and algorithmic
              problem-solving."
              link="https://github.com/Ciriously/AICUBESOLVER"
            />
          </Col> 
          
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Mario}
              isBlog={false}
              title="Mario Game using Python(Game Development)"
              
              description=" A python remake of the classic Super Mario BrosThe game based on pygame with loading .tmx level using pytmx.
              Paper."
              link="https://github.com/Ciriously/MarioGame.py"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Todo}
              isBlog={false}
              title="Widget To-do App"
              
              description=" A Simple To-do app design in flutter to keep track of your task on daily basis. You can add project, labels and due-date to your tasks."
              link="https://imgur.com/a/PxvoYRR"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="Weather App based on your location."
              description=" Day Forecast app that works on Android and uses latest tools (Kotlin, Navigation, Room, LiveData, Databinding, Dagger 2).."
              link= "https://imgur.com/a/jaBajIP"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={AMS}
              isBlog={false}
              title="Attendace Management system using face recognization."
              description="We seek to provide a valuable attendance service for both teachers and students. Reduce manual process errors by provide automated and a reliable attendance system uses face recognition technology.
              Here I am working on Face recognition based Attendance Management System by using OpenCV(Python). One can mark thier attendance by simply facing the camera."
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Hsm}
              isBlog={false}
              title="Hospitalmangement using CMD."
              description="A Hospital management system using java on CMD/terminal."
              link= "https://imgur.com/a/e0YQYkf"
              
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={paint}
              isBlog={false}
              title="Custom paint App"
              description="A basic drawing program. The application allows user to select a color, size and to draw with their finger on the screen.The application allows to clear the drawing.The application allows to save and continue drawing later.This app lets you draw and save your signature to external storage as png image."
              link="https://imgur.com/a/lV29eID"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gallery}
              isBlog={false}
              title="Digital photography/Art Website portfolio."
              description="A Portfolio website built with Sass,Js and Html."
              link= "https://ciriouslysgallery.web.app/"
              
            />
          </Col>





          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Hsmjava}
              isBlog={false}
              title="Hospital Management System with GUI"
              description="HMS was introduced to solve the complications coming from managing all the paper works of every patient associated with the various departments of hospitalization with confidentiality. HMS provides the ability to manage all the paperwork in one place, reducing the work of staff in arranging and analyzing the paperwork of the patients."
              link="https://imgur.com/a/AnfAt35"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={MiniMp3}
              isBlog={false}
              title="Mini Mp3 Player"
              description="A mini mp3 player I built using Html,Js & css."
              link="https://adimp3.netlify.app/"
            />
          </Col>




          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={website}
              isBlog={false}
              title="Website front-end"
              description="A Website built using Reactjs in a team of 3 during my internship as Web developer at Staticint.educare."
              link="https://staticinteducare.herokuapp.com/"
            />
            
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={MP3}
              isBlog={false}
              title="Music-Player"
              description="A Mini-music player I built using Vue.js."
              link="https://mp3vuejsaditya.netlify.app/"
            />
            
          </Col>
        </Row>
       <h1 className="project-heading">
          I'm Still learning <strong className="purple">Something new </strong> everyday..
        </h1>
        <p style={{ color: "white" }}>❤️🖤❤️</p>
        <Row style={{ justifyContent: "center" }}>
       
         
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
